import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
import useAuth from '../hooks/useAuth';
import { USER_ROLES } from '../constants/keywords';
import { PATH_DASHBOARD, PATH_USER_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const { user } = useAuth();
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <img src="/logo/logo_capital_monk.png" />
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <RouterLink
      to={user?.role === USER_ROLES.ADMIN ? PATH_DASHBOARD.root : PATH_USER_DASHBOARD.root}
    >
      {logo}
    </RouterLink>
  );
}
